<template>
	<div class="whole">
		<div class="bottomContent wrapper1200 ">
			<div class="customerService">
				<div>售后客服</div>
				<div>{{customerService.afterSale}}</div>
			</div>
			<div class="navigation">
				<div class="title">底部导航</div>
				<div class="content flex row-between">
					<div @click="switchType('/index/home')">首页</div>
					<div @click="switchType('/knowledgeBase')">中医知识库</div>
					<div @click="switchType('/drynessPathology')">燥症诊断</div>
					<div @click="switchType('/dietaryGuidance')">饮食指导</div>
					<div @click="switchType('/caseInformation')">病例信息</div>
					<div @click="switchType('/personalInformation')">个人信息</div>
				</div>
				<div class="contact">联系我们</div>
				<div class="information">公司：{{contactUs.company}}</div>
				<div class="information">地址：{{contactUs.address}} </div>
				<div class="information">电话：{{contactUs.phone}}</div>
			</div>
			<div class="qrCode">
				<img :src="customerService.qcCode" alt="" />
				<div class="siAomei">
					<div>扫描二维码</div>
					<div>打开西北燥症诊断小程序</div>
				</div>
			</div>
		</div>
		<div class="bottomContents wrapper1200">
			<div><a href="https://beian.miit.gov.cn/#/Integrated/index">备案号：新ICP备2025018158号-1 </a></div>
			<div>主办单位名称：新疆万新普康商贸有限公司</div>
		</div>
	</div>
</template>

<script>
	import {
		setContent
	} from "@/api/api.js"
	export default {
		data() {
			return {
				contactUs: '',
				customerService: ''
			}
		},
		created() {
			this.setUp()
		},
		methods: {
			switchType(url) {
				// this.single = index
				// sessionStorage.setItem('index', item.url)
				this.$router.push({
					path: url
					// query: {
					// 	id: '123'
					// }
				}).catch(() => {})
			},
			setUp() {

				setContent({
					groupKey: "kf"
				}).then(res => {
					this.customerService = res.data
				})
				setContent({
					groupKey: "relation"
				}).then(res => {
					this.contactUs = res.data
				})
			}
		}
	}
</script>

<style lang="scss">
	.bottomContents {
		margin: 0 auto;
		position: absolute;
		left: 0;
		right: 0;
		bottom: 10px;
		display: flex;
		justify-content: space-evenly;

		div {
			color: #999999;
			font-size: 14px;
		}

		a {
			color: #999999;
			text-decoration: none;
			font-size: 14px;
		}
	}

	.whole {
		height: 374px;
		background: #2C2723;
		cursor: default;
		position: relative;
	}

	.bottomContent {
		display: flex;
		justify-content: space-between;
		padding-top: 60px;

		.customerService {
			div:nth-of-type(1) {
				font-family: Microsoft YaHei, Microsoft YaHei;
				font-weight: 400;
				font-size: 14px;
				color: #999999;
			}

			div:nth-of-type(2) {
				font-family: Microsoft YaHei, Microsoft YaHei;
				font-weight: 400;
				font-size: 24px;
				color: #FFFFFF;
				margin-top: 20px;
			}
		}

		.navigation {
			.title {
				font-family: Microsoft YaHei, Microsoft YaHei;
				font-weight: 400;
				font-size: 14px;
				color: #999999;
			}

			.content {
				font-family: Microsoft YaHei, Microsoft YaHei;
				font-weight: 400;
				font-size: 12px;
				color: #CCCCCC;
				margin-top: 20px;

				div {
					margin-right: 30px;
				}
			}

			.contact {
				font-family: Microsoft YaHei, Microsoft YaHei;
				font-weight: 400;
				font-size: 14px;
				color: #999999;
				margin-top: 40px;
				margin-bottom: 20px;
			}

			.information {
				font-family: Microsoft YaHei, Microsoft YaHei;
				font-weight: 400;
				font-size: 12px;
				color: #CCCCCC;
				margin-bottom: 20px;
			}
		}

		.qrCode {
			text-align: center;
			margin-top: 40px;

			img {
				width: 119px;
				height: 121px;
			}

			.siAomei {
				width: 132px;
				height: 32px;
				font-family: Microsoft YaHei, Microsoft YaHei;
				font-weight: 400;
				font-size: 12px;
				color: #CCCCCC;
			}
		}
	}
</style>